@if ((isTeamLead && teamList?.length > 0) || isManager) {
  <div class="d-flex gap-2">
    @if ((isTeamLead && teamList?.length > 0) || isManager) {
      <div class="sales-header-bar d-flex align-items-center gap-3 px-0 py-2"
        >
        <div class="btn-group bg-light rounded-pill border">
          @if (salesView.dashboardView$ | async; as view) {
            <div class="d-flex align-items-center">
              <button type="button" class="btn rounded-pill custom-btn fs-14 fs-sm-14 fw-bold border-0"
                [class.tab-active]="view === primaryTab"
                [class.shadow-sm]="view === primaryTab"
                [class.text-secondary]="view !== primaryTab"
                (click)="setView(primaryTab)">
                {{ primaryLabel }}
              </button>
              <button type="button" class="btn rounded-pill custom-btn fs-14 fs-sm-14 fw-bold border-0"
                [class.tab-active]="view === secondaryTab"
                [class.shadow-sm]="view === secondaryTab"
                [class.text-secondary]="view !== secondaryTab"
                (click)="setView(secondaryTab)">
                {{ secondaryLabel }}
              </button>
            </div>
          }
        </div>
      </div>
    }
    <div class="agents d-flex align-items-center border-0 me-2">
      @if (isL1TeamLead && (salesView.dashboardView$ | async) === 'team' && teamList.length > 0) {
        <select class="form-select form-select rounded-pill d-flex gap-2 fs-14 fw-400 fs-sm-14 all-agent" [ngModel]="(salesView.selectedAdminId$ | async) ?? ''"
          (ngModelChange)="salesView.setSelectedAdminId($event === '' ? null : +$event)">
          <option value="">All agents</option>
          @for (member of teamList; track member) {
            <option [value]="member.admin_id">{{ member.admin_name
            || member.admin_email || 'Agent ' + member.admin_id }}</option>
          }
        </select>
      }
    </div>
  </div>
}
